import FilterButton from "./FilterButton";
import FilterPanel from "./FilterPanel";

export default {
    button: FilterButton,
    name: "filter",
    panel: FilterPanel,
};
